<template>
  <div class="role-page full-height">
    <table-con>
      <div slot="breadcrumb">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/orders' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>用户管理</el-breadcrumb-item>
          <el-breadcrumb-item>用户列表</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div slot="search">
        <el-row class="search-row">
          <el-col :span="6" class="display-row">
            <div class="query-title">用户姓名:</div>
            <div class="flex1">
              <el-input placeholder="请输入内容" clearable v-model="queryInfo.realName" size="small"
                @keyup.enter.native="searchCustomer">
              </el-input>
            </div>
          </el-col>
          <el-col :span="6" class="display-row">
            <div class="query-title">用户ID:</div>
            <div class="flex1">
              <el-input placeholder="请输入内容" clearable v-model="queryInfo.userName" size="small"
                @keyup.enter.native="searchCustomer">
              </el-input>
            </div>
          </el-col>
          <el-col :span="6" class="display-row">
            <div class="query-title">代购权限:</div>
            <div class="flex1">
              <el-select v-model="queryInfo.hotboomFlag" placeholder="请选择" size="small" clearable>
                <el-option v-for="item in hotboomOptions" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </div>
          </el-col>
          <el-col :span="6" class="display-row">
            <div style="text-align: right; width: 100%; padding-right: 10px">
              <el-button class="search-btn btn-blue" @click="updateAgreement">更新协议</el-button>
              <el-button class="search-btn btn-green" @click="lookAllPact">条约查看记录</el-button>
              <el-button class="search-btn btn-gray" @click="clearConditions">重置</el-button>
              <el-button class="search-btn btn-blue" @click="searchCustomer">搜索</el-button>
              <el-button class="search-btn btn-green" @click="distribution">分配</el-button>
              <el-button class="search-btn btn-green" @click="exportAction">导出</el-button>
            </div>
          </el-col>
        </el-row>
      </div>
      <div slot="table" class="full-height display-col">
        <el-table :data="customerList" :header-cell-style="tableStyle.headerStyle" v-loading="isLoading"
          :cell-style="tableStyle.cellStyle" border ref="multipleTable" @select="tableSelect" @select-all="tableSelectAll"
          height="550">
          <el-table-column align="center" type="selection"> </el-table-column>
          <el-table-column align="center" type="index" label="序号" width="40">
          </el-table-column>
          <el-table-column prop="clientMasterUserName" align="center"  label="主账号">
          </el-table-column>
          <el-table-column align="center" label="操作" width="150">
            <template slot-scope="scope">
              <el-button class="list-btn-four btn-green" @click="costDeal(scope.row)">费用处理</el-button><br />
              <el-button class="list-btn-four btn-blue" @click="reply(scope.row)">提醒</el-button><br />
              <el-button class="list-btn-four btn-deepblue" @click="changeStatus(scope.row)">
                {{ scope.row.userFlag == 0 ? "禁用" : "启用" }}</el-button><br />
              <el-button class="list-btn-four btn-deepblue" @click="changeHotboomFlag(scope.row)">
                {{ scope.row.hotboomFlag == 0 ? "开启代购" : "关闭代购" }}</el-button><br />
              <el-button class="list-btn-four btn-green" @click="costSetting(scope.row)">费用配置</el-button><br />
              <el-button class="list-btn-four btn-green" style="width: 100px;" @click="freeStorageDurationSetting(scope.row)">免费仓储时长</el-button><br />
              <el-button class="list-btn-four btn-green" @click="inspectSetting(scope.row)">检品配置</el-button><br />
              <el-button class="list-btn-four btn-green" style="width: 100px;" @click="logisticsCompanySetting(scope.row)">物流公司配置</el-button><br />
              <el-button class="list-btn-four btn-green" @click="storageLocation(scope.row)">绑定库位</el-button><br />
              <el-button class="list-btn-four btn-green" style="width: 100px;" @click="lookLocation(scope.row)">条约查看记录</el-button><br />
              <el-button class="list-btn-four btn-green" style="width: 100px;" @click="changeHistoryFile(scope.row)">
                {{ scope.row.historyFile == 0 ? "开启历史文件" : "关闭历史文件" }}</el-button><br />
              <el-button class="list-btn-four btn-green" style="width: 100px;" @click="changeBundle(scope.row)">
                {{ scope.row.bundle == 0 ? "开启同捆" : "关闭同捆" }}</el-button><br />
              <!--<el-button class="list-btn-four btn-green" style="width: 110px;" @click="changeAiChatEnabled(scope.row)">-->
              <!--  {{ scope.row.aiChatEnabled == 0 ? "开启智能客服" : "禁用智能客服" }}</el-button><br />-->
            </template>
          </el-table-column>
          <el-table-column prop="userName" align="center"  label="用户ID">
          </el-table-column>

          <el-table-column prop="locatorNos" align="center" label="库位">
            <template v-slot="{row}">
              <div v-for="(vv,ii) in row.locatorNos.split(',') || []" :key="ii">
                {{vv}}
              </div>
            </template>
          </el-table-column>

          <el-table-column prop="freeStorageDuration" align="center"  label="免费仓储时长(天)"></el-table-column>

          <el-table-column prop="realName" align="center"  label="用户姓名">
          </el-table-column>
          <el-table-column prop="balance" align="center" :index="indexMethod" sortable label="余额（元）">
            <template v-slot="scope">
              {{ addThousandSeparator(scope.row.balance || 0) }}
            </template>
          </el-table-column>
          <el-table-column prop="createTime" label="创建时间" align="center" sortable width="160" :index="indexMethod"
            :formatter="dateFormatYMDHMS">
          </el-table-column>
          <el-table-column prop="staffUser" label="负责人" align="center">
            <template v-slot="scope">
              <el-tag v-for="(item, i) in JSON.parse(scope.row.staffUser)" :key="i" size="medium" style="margin:5px 0 0 5px">
                {{ item.userName }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="userFlag" label="用户状态" align="center" :index="indexMethod" sortable :formatter="statusFormatter">
          </el-table-column>
          <el-table-column prop="hotboomFlag" label="代购权限" align="center" :formatter="hotboomFormatter">
          </el-table-column>
          <el-table-column prop="latestSigninTime" label="最新登录时间" align="center" sortable width="160" :index="indexMethod">
            <template v-slot="scope">
              {{ scope.row.latestSigninTime | dateFormatToSecond }}
            </template>
          </el-table-column>
        </el-table>
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="queryInfo.pageNum"
          :page-sizes="[5, 10, 20, 50, 100, 200]" :page-size="queryInfo.pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="total"></el-pagination>
      </div>
    </table-con>
    <!-- 分配用户 -->
    <el-dialog title="分配用户" :visible.sync="distributionVisible" width="30%" @close="distributionDialogClose">
      <el-form label-width="120px" class="add-role-form">
        <el-form-item label="负责人：">
          <el-select multiple  v-model="distributionInfo.staffUser" value-key="userId" filterable placeholder="输入用户名进行搜素">
            <el-option v-for="item in staffList" :key="item.userId" :label="item.userName" :value="item">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button class="form-btn btn-gray" @click="closeDistributionDialog">取 消</el-button>
        <el-button class="form-btn btn-blue" @click="confirmDistribution">提 交</el-button>
      </span>
    </el-dialog>
    <!-- 费用处理 -->
    <el-dialog title="费用处理" :visible.sync="costDealVisible" width="30%" @close="costDealDialogClose">
      <el-form label-width="120px" :model="costDealInfo" ref="costDealForm" :rules="costDealRole">
        <el-form-item label="收支类型：" prop="typeDetail">
          <el-radio-group v-model="costDealInfo.typeDetail">
            <el-radio :label="1">充值</el-radio>
            <el-radio :label="4">赔偿</el-radio>
            <el-radio :label="5">扣款</el-radio>
            <el-radio :label="6">退金（提现）</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="金额（元）：" prop="money">
          <el-input v-model="costDealInfo.money" style="width: 300px" placeholder="请输入金额"></el-input>
        </el-form-item>
        <el-form-item label="关联订单号：" prop="orderNo">
          <el-input v-model="costDealInfo.orderNo" style="width:300px" placeholder="请输入关联订单号">
          </el-input>
        </el-form-item>
        <el-form-item label="交易说明：" prop="orderNo">
          <el-input v-model="costDealInfo.dealDesc" style="width:300px" placeholder="请输入交易说明">
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button class="form-btn btn-gray" @click="closeCostDealDialog">取 消</el-button>
        <el-button class="form-btn btn-blue" @click="confirmCostDeal">提 交</el-button>
      </span>
    </el-dialog>

    <!-- 费用配置 -->
    <el-dialog title="费用配置" :visible.sync="settingDialogVisible" width="460px" @close="settingDialogClose">
      <el-form :model="settingInfo" :rules="csotSettingRules" ref="settingInfo" label-width="150px" class="demo-replyInfo">
        <el-form-item label="姓名：">
          <span>{{settingInfo.realName}}</span>
        </el-form-item>
        <el-form-item label="用户名：">
          <span>{{settingInfo.userName}}</span>
        </el-form-item>
        <el-form-item label="代购手续费：" prop="serviceRate">
          <div class="lx-flex-row">
            <el-input v-model="settingInfo.serviceRate"></el-input><span class="lx-ml5">%</span>
          </div>

        </el-form-item>
      </el-form>
      <div style="text-align:right;">
        <el-button class="form-btn btn-gray" @click="settingDialogClose">取 消</el-button>
        <el-button class="form-btn btn-blue" @click="settingSave('settingInfo')" size="small">提 交</el-button>
      </div>
    </el-dialog>

    <!-- 检品选项配置 -->
    <el-dialog title="检品选项配置" :visible.sync="inspectSettingDialogVisible" width="30%">
      <el-form label-width="120px" class="add-role-form">
        <el-form-item label="特殊检品选项：">
          <el-select v-model="inspectSettingInfo.inspectOption" multiple placeholder="请选择">
            <el-option v-for="item in inspectList" :key="item.nameCd" :label="item.nameZh" :value="item.nameCd">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button class="form-btn btn-gray" @click="inspectSettingDialogVisible = false">取 消</el-button>
        <el-button class="form-btn btn-blue" @click="confirmInspectSetting">提 交</el-button>
      </span>
    </el-dialog>

    <!-- 免费仓储时长配置 -->
    <el-dialog title="免费仓储时长配置" :visible.sync="freeStorageDurationSettingDialogVisible" width="30%">
      <el-form label-width="120px" class="add-role-form">
        <el-form-item label="姓名：">
          <span>{{freeStorageDurationSettingInfo.realName}}</span>
        </el-form-item>
        <el-form-item label="用户名：">
          <span>{{freeStorageDurationSettingInfo.userName}}</span>
        </el-form-item>
        <el-form-item label="免费仓储时长：" prop="serviceRate">
          <div class="lx-flex-row">
            <el-input v-model="freeStorageDurationSettingInfo.freeStorageDuration"></el-input><span class="lx-ml5">天</span>
          </div>

        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button class="form-btn btn-gray" @click="freeStorageDurationSettingDialogVisible = false">取 消</el-button>
        <el-button class="form-btn btn-blue" @click="confirmFreeStorageDurationSetting">提 交</el-button>
      </span>
    </el-dialog>

    <!-- 物流公司配置 -->
    <el-dialog title="物流公司配置" :visible.sync="logisticsCompanySettingDialogVisible" width="30%">
      <el-form label-width="120px" class="add-role-form">
        <el-form-item label="物流公司：">
          <el-select v-model="logisticsCompanySettingInfo.logisticsCompanyOption" multiple placeholder="请选择">
              <el-option v-for="item in logisticsCompanyList" :key="item.id.toString()" :label="item.companyName" :value="item.id.toString()">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button class="form-btn btn-gray" @click="logisticsCompanySettingDialogVisible = false">取 消</el-button>
        <el-button class="form-btn btn-blue" @click="confirmLogisticsCompanySetting">提 交</el-button>
      </span>
    </el-dialog>

    <!--绑定库位-->
    <el-dialog title="绑定库位" :visible.sync="storageLocationDialogVisible" width="30%">
      <el-form label-width="120px" class="add-role-form">
        <el-form-item label="库位：">
          <el-select v-model="storageLocationInfo.locatorId" multiple collapse-tags  placeholder="请选择">
            <el-option v-for="item in storageLocationList" :key="item.id" :label="item.locatorNo" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button class="form-btn btn-gray" @click="storageLocationDialogVisible = false">取 消</el-button>
        <el-button class="form-btn btn-blue" @click="storageLocationSetting">提 交</el-button>
      </span>
    </el-dialog>


    <!-- 更新协议 -->
    <el-dialog title="更新协议" :visible.sync="agreementDialogVisible" width="500px" @close="agreementDialogClose">
      <el-form :model="agreementInfo" :rules="agreementRules" ref="agreementForm" label-width="100px">
        <el-form-item label="协议号：" prop="agreementType">
          <el-select v-model="agreementInfo.agreementType" placeholder="请选择协议" style="width: 100%" @change="onAgreementTypeChange">
            <el-option label="用户服务协议" :value="1"></el-option>
            <el-option label="隐私政策" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="当前版本：" v-if="currentAgreement">
          <el-link type="primary" :underline="false" :href="currentAgreement.url" target="_blank">{{ currentAgreement.version }}（{{ currentAgreement.fileName }}）</el-link>
        </el-form-item>
        <el-form-item label="版本号：" prop="version">
          <el-input v-model="agreementInfo.version" placeholder="请输入版本号，如 1.5" style="width: 100%"></el-input>
        </el-form-item>
        <el-form-item label="上传文件：" prop="agreementUrl">
          <my-upload v-model="agreementInfo.agreementUrl" :fileName.sync="agreementInfo.agreementFileName"
            :limit="1" listType="text" accept=".pdf" modular="agreement" size="mini" :keepOriginalName="true" class="change-upload-size">
            <el-button class="list-btn btn-blue">点击上传</el-button>
          </my-upload>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button class="form-btn btn-gray" @click="agreementDialogVisible = false">取 消</el-button>
        <el-button class="form-btn btn-blue" @click="confirmUpdateAgreement">确 认</el-button>
      </span>
    </el-dialog>

    <!-- <MessageTip :visiable.sync="isVisiable" :userName="replyMessageInfo.userName" messageType="其他消息" httpUrl="customer/message" @confirm="onConfirmMsg"></MessageTip>
    <MessageTip :visiable.sync="isVisiable" :userName="replyMessageInfo.userName" messageType="普通消息" httpUrl="customer/message" @confirm="onConfirmMsg"></MessageTip> -->
    <MessageTip :visiable.sync="isVisiable" :info="replyMessageInfo" @confirm="onConfirmMsg"></MessageTip>
  </div>
</template>

<script>
import tableCon from "../../views/tableContainer";
import MessageTip from '@/components/MessageTip/index'

export default {
  name: 'customers',
  components: { tableCon, MessageTip },
  data () {
    return {
      // 更新协议
      agreementDialogVisible: false,
      agreementInfo: {
        agreementType: '',
        version: '',
        agreementUrl: '',
        agreementFileName: '',
      },
      currentAgreement: null,
      agreementRules: {
        agreementType: [
          { required: true, message: '请选择协议', trigger: 'change' }
        ],
        version: [
          { required: true, message: '请输入版本号', trigger: 'blur' }
        ],
        agreementUrl: [
          { required: true, message: '请上传协议文件', trigger: 'change' }
        ],
      },
      storageLocationInfo: {
        userId: '',
        locatorId: []
      },
      //绑定库位id
      storageLocationList:[],
      //绑定库位弹窗
      storageLocationDialogVisible : false,
      inspectSettingDialogVisible : false,
      logisticsCompanySettingDialogVisible : false,
      freeStorageDurationSettingDialogVisible : false,
      logisticsCompanyList:[],
      inspectList:[],
      inspectSettingInfo: {
        userId: '',
        inspectOption:[]
      },
      freeStorageDurationSettingInfo: {
        userId: '',
        userName: '',
        realName: '',
        freeStorageDuration: '',
      },
      logisticsCompanySettingInfo:{
        userId: '',
        logisticsCompanyOption:[]
      },
      fileList: [],
      costDealRole: {
        typeDetail: [
          { required: true, message: "请选择收支类型", trigger: "change" },
        ],
        money: [
          { required: true, message: "请输入金额", trigger: "blur" },
          {
            validator: (rule, value, callback) => {
              var reg = /^-?\d{1,7}(?:\.\d{1,2})?$/; //小数点左边最高16位，小数点右边最多2位
              if (reg.test(value)) {
                callback();
              } else {
                callback(new Error("输入正确的数字,小数点后可1到2位"));
              }
            },
            trigger: "blur",
          },
        ],
      },
      hotboomOptions: [
        {
          value: '0',
          label: '关闭'
        }, {
          value: '1',
          label: '开启'
        }
      ],
      isLoading: false,
      rules: {
        remindingTitle: [
          { required: true, message: '请输入标题', trigger: 'blur' }
        ],
        remindingContent: [
          { required: true, message: '请输入消息提醒内容', trigger: 'blur' }
        ]
      },
      csotSettingRules: {
        serviceRate: [
          { required: true, message: '请输入FBA手续费', trigger: 'blur' }
        ],
        serviceFee: [
          { required: true, message: '请输入非FBA代购', trigger: 'blur' }
        ]
      },
      queryInfo: {
        userName: "",
        realName: "",
        pageSize: 10,
        pageNum: 1,
      },
      replyInfo: {
        remindingUserName: '',
        remindingContent: '',
        remindingTitle: '',
        replyPicture: '',
        imgFileList: [],
        imgFileListStr: ''
      },
      settingInfo: {
        userId: '',
        userName: '',
        realName: '',
        serviceRate: '',
      },
      customerList: [],
      replyMessageInfo: {},  //发消息页面显示表格所在行内容
      total: 0,
      distributionInfo: {
        userIds: [],
        staffUser: [],
      },
      staffList: [],
      selectedStaffList: "",
      distributionVisible: false,
      replyDialogVisible: false,
      settingDialogVisible: false,
      costDealVisible: false,
      costDealInfo: {
        userId: "",
        typeDetail: "",
        money: "",
        orderNo: "",
        dealDesc: ""
      },
      listObj: [],
      imgDataObj: {
        policy: '',
        signature: '',
        key: '',
        ossaccessKeyId: '',
        dir: '',
        host: '',
        timeStamp: ''
      },
      isVisiable: false, // 消息提醒弹框
    };
  },
  methods: {
    lookAllPact(){
      this.$modalDialog(() => import('./cmp/stock-order-all.vue'), {

      }).then(
          () => {
            this.getCustomerList();
          },
          () => {
          }
      )
    },

    lookLocation(row){
      this.$modalDialog(() => import('./cmp/stock-order.vue'), {
        row
      }).then(
          () => {
            this.getCustomerList();
          },
          () => {
          }
      )
      console.log(row)
    },
    costDeal (row) {
      this.costDealDialongInit();
      this.costDealInfo.userId = row.userId;
      this.costDealVisible = true;
      let _this = this;
      this.$nextTick(function () {
        _this.$refs.costDealForm.clearValidate();
      });
    },
    costDealDialogClose () { },
    costDealDialongInit () {
      this.costDealInfo.userId = "";
      this.costDealInfo.typeDetail = "";
      this.costDealInfo.money = "";
      this.costDealInfo.orderNo = "";
      this.costDealInfo.dealDesc = "";
    },
    closeCostDealDialog () {
      this.costDealVisible = false;
    },
    confirmCostDeal () {
      console.log(this.costDealInfo);
      var my = this;
      //保存按钮
      this.$refs.costDealForm.validate(async function (valid) {
        if (valid) {
          //新增和编辑
          var url = "customer/costDeal";
          const { data: res } = await my.$http.post(url, my.costDealInfo);
          if (res.code == 200) {
            my.$message({
              type: "success",
              message: res.message,
            });
            my.getCustomerList();
            my.costDealVisible = false;
          } else {
            my.$message({
              type: "warning",
              message: res.message,
            });
          }
        }
      });
    },
    searchCustomer () {
      this.queryInfo.pageNum = 1;
      this.queryInfo.pageSize = 10;
      this.getCustomerList();
    },
    async changeStatus (row) {
      let status = "";
      var strStatus = "";
      if (row.userFlag == "1") {
        status = "0";
        strStatus = "启用"
      } else {
        status = "1";
        strStatus = "禁用"
      }
      this.$confirm(`确定要${strStatus}该用户吗？`,  {
        confirmButtonText: "确定",
        confirmButtonClass: "form-btn btn-blue",
        cancelButtonText: "取消",
        cancelButtonClass: "form-btn btn-gray",
        type: "warning"
      }).then(async () => {
        const { data: res } = await this.$http.post("/customer/usable", {
          userId: row.userId,
          userFlag: status,
        });
        if (res.code == 200) {
          this.$message({
            type: "success",
            message: res.message,
          });
          this.getCustomerList();
        } else {
          this.$message.error(res.message);
        }
      }).catch(() => {
        this.$message({
          type: "info",
          message: "已取消改操作"
        });
      });
      /*const { data: res } = await this.$http.post("/customer/usable", {
        userId: row.userId,
        userFlag: status,
      });
      if (res.code == 200) {
        this.$message({
          type: "success",
          message: res.message,
        });
        this.getCustomerList();
      } else {
        this.$message.error(res.message);
      }*/
    },
    async changeHotboomFlag (row) {
      let status = "";
      if (row.hotboomFlag == "1") {
        status = "0";
      } else {
        status = "1";
      }
      const { data: res } = await this.$http.post("/customer/hotboomFlag", {
        userId: row.userId,
        hotboomFlag: status,
      });
      if (res.code == 200) {
        this.$message({
          type: "success",
          message: res.message,
        });
        this.getCustomerList();
      } else {
        this.$message.error(res.message);
      }
    },
    async changeHistoryFile (row) {
      let status = "";
      if (row.historyFile == "1") {
        status = "0";
      } else {
        status = "1";
      }
      const { data: res } = await this.$http.post("/customer/historyFileChange", {
        userId: row.userId,
        historyFile: status,
      });
      if (res.code == 200) {
        this.$message({
          type: "success",
          message: res.message,
        });
        this.getCustomerList();
      } else {
        this.$message.error(res.message);
      }
    },
    async changeBundle (row) {
      let bundle = "";
      if (row.bundle == "1") {
        bundle = "0";
      } else {
        bundle = "1";
      }
      const { data: res } = await this.$http.post("/customer/bundleChange", {
        userId: row.userId,
        bundle: bundle,
      });
      if (res.code == 200) {
        this.$message({
          type: "success",
          message: res.message,
        });
        this.getCustomerList();
      } else {
        this.$message.error(res.message);
      }
    },
    async changeAiChatEnabled (row) {
      let aiChatEnabled = "";
      if (row.aiChatEnabled == "1") {
        aiChatEnabled = "0";
      } else {
        aiChatEnabled = "1";
      }
      const { data: res } = await this.$http.post("/customer/updateAiChatEnabled", {
        userId: row.userId,
        aiChatEnabled: aiChatEnabled,
      });
      if (res.code == 200) {
        this.$message({
          type: "success",
          message: res.message,
        });
        this.getCustomerList();
      } else {
        this.$message.error(res.message);
      }
    },
    async confirmDistribution () {

      let staffUser = this.distributionInfo.staffUser.map(item =>{
        return {userId:item.userId, userName:item.userName}
      })
      const { data: res } = await this.$http.post(
        "/customer/distribution",
          {userIds: this.distributionInfo.userIds, staffUser: JSON.stringify(staffUser)}
      );
      if (res.code == 200) {
        this.$message({
          type: "success",
          message: res.message,
        });
      } else {
        this.$message.error(res.message);
      }
      this.distributionVisible = false;
      this.getCustomerList();
    },
    closeDistributionDialog () {
      this.distributionVisible = false;
    },
    distributionDialogClose () { },
    async getStaffs () {
      const { data: res } = await this.$http.get(
        "emp/empSystemManage/listStartUse"
      );
      this.staffList = res.data;
      // console.log('this.staffList',this.staffList);
      if(this.distributionInfo.userIds.length === 1){
        let ids = this.distributionInfo.userIds[0]
        let arr = this.customerList.filter(v=>{
          return v.userId === ids
        });
        this.distributionInfo.staffUser = JSON.parse(arr[0].staffUser)
      }else {
        this.distributionInfo.staffUser = []
      }

    },
    tableSelect (selection, row) {
      this.tableSelectAll(selection);
    },
    tableSelectAll (selection) {
      this.distributionInfo.userIds = [];
      selection.forEach((item) => {
        this.distributionInfo.userIds.push(item.userId);
      });
    },
    distribution () {
      this.distributionInfo.staffUser = [];
      if (this.distributionInfo.userIds.length > 0) {
        this.getStaffs();
        this.distributionVisible = true;
      } else {
        this.$message({
          type: "warning",
          message: "请先选择用户",
        });
      }
    },
    dateFormatYMDHMS (row, column) {
      var dateStr = row[column.property];
      if (dateStr != null) {
        var date = new Date(parseInt(dateStr) * 1000);
        return (
          date.getFullYear() +
          "-" +
          (date.getMonth() + 1 < 10
            ? "0" + (date.getMonth() + 1)
            : date.getMonth() + 1) +
          "-" +
          date.getDate() +
          " " +
          date.getHours() +
          ":" +
          date.getMinutes() +
          ":" +
          date.getSeconds()
        );
      }
      return "";
    },
    indexMethod (index) {
      return (this.pageNum - 1) * this.pageSize + index + 1;
    },
    statusFormatter (row, column) {
      if (row.userFlag == 0) {
        return "启用";
      } else {
        return "禁用";
      }
    },
    hotboomFormatter (row, column) {
      if (row.hotboomFlag == 0) {
        return "关闭";
      } else {
        return "开启";
      }
    },
    handleSizeChange (pageSize) {
      this.queryInfo.pageSize = pageSize;
      this.getCustomerList();
    },
    handleCurrentChange (pageNumber) {
      this.queryInfo.pageNum = pageNumber;
      this.getCustomerList();
    },
    clearConditions () {
      this.queryInfo = {
        userName: '',
        userId: ''
      }
      this.distributionInfo = {
        userIds: [],
        staffUserId: []
      }
      this.$refs.multipleTable.clearSelection();
    },
    async exportAction () {
      this.$http({
        url: '/customer/exportAction',
        method: 'get',
        params: this.queryInfo,
        responseType: 'blob', // 表明返回服务器返回的数据类型
        headers: {
          'Content-Type': 'application/json'
        },
        data: {
          //接口参数
        }
      }).then((res) => {
        //创建一个隐藏的a连接，
        const link = document.createElement('a');
        let blob = new Blob([res.data], { type: 'application/vnd.ms-excel' });
        link.style.display = 'none';
        //设置连接
        link.href = URL.createObjectURL(blob);
        link.download = '用户列表.xlsx';
        document.body.appendChild(link);
        //模拟点击事件
        link.click();
      }).catch((err) => {
        console.log(err);
      })
    },
    async getCustomerList () {
      this.isLoading = true
      const { data: res } = await this.$http.get("customer/customerList", {
        params: this.queryInfo,
      });
      this.customerList = res.data.list;
      this.total = res.data.total;
      this.isLoading = false
    },
    async addCostSet () {
      var url = 'customer/costSet';
      const { data: res } = await this.$http.post(url, this.settingInfo);
      if (res.code == 200) {
        this.$message({
          type: 'success',
          message: res.message
        })
        this.getCustomerList()
      }
      else {
        this.$message({
          type: 'warning',
          message: res.message
        })
      }
    },
    settingSave (formName) {    //保存消息提醒内容按钮
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.addCostSet();
          this.settingDialogVisible = false;
        } else {
          this.$message.error('必填项不能为空，请重新填写并提交！');
          return false;
        }
      });
    },

    initReplyForm () {   //初始化消息提醒弹窗的内容
      this.replyInfo = {
        remindingContent: '',
        remindingTitle: '',
        replyPicture: ''
      };
    },
    //消息提醒
    reply (row) {
      this.replyMessageInfo = row;
      this.isVisiable = true
    },
    onConfirmMsg() {
      this.isVisiable = false
    },

    costSetting (row) {     //费用配置
      this.settingDialogVisible = true;
      this.settingInfo = {
        id: row.id,
        userId: row.userId,
        userName: row.userName,
        realName: row.realName,
        serviceRate: row.serviceRate,
      }
    },
    settingDialogClose () {    //关闭消息提醒弹窗
      this.settingDialogVisible = false;
    },
    async inspectSetting(row){
      const { data: res } = await this.$http.get('/order/getNameList', {params: {nameClass:'INSPECTION',isPrivate:'1'}});
      this.inspectList = res.data;

      this.inspectSettingDialogVisible = true
      if (row.inspectOption != null && row.inspectOption != ''){
        row.inspectOption = row.inspectOption.split(',')
      }
      this.inspectSettingInfo = row
    },
    async freeStorageDurationSetting(row){
      this.freeStorageDurationSettingInfo = row
      this.freeStorageDurationSettingDialogVisible = true
    },
    async logisticsCompanySetting(row){
      const { data: res } = await this.$http.get("cms/logisticsCompany/getDropDownForLineList/null?isPrivate=1&username="+row.userName)
      this.logisticsCompanyList = res.data


      this.logisticsCompanySettingDialogVisible = true
      if (row.logisticsCompanyOption != null && row.logisticsCompanyOption != ''){
        row.logisticsCompanyOption = row.logisticsCompanyOption.split(',')
      }
      this.logisticsCompanySettingInfo = row
    },

    async confirmInspectSetting(){
      if (this.inspectSettingInfo.inspectOption.length > 0){
        this.inspectSettingInfo.inspectOption = this.inspectSettingInfo.inspectOption.join(',')
      }else {
        this.inspectSettingInfo.inspectOption = ''
      }
      const { data: res } = await this.$http.post('customer/inspectSetting', this.inspectSettingInfo);
      if (res.code != 200) {
        this.$message({
          type: 'warning',
          message: res.message
        })
      }
      this.inspectSettingDialogVisible = false
      this.$message({
        type: 'success',
        message: '操作成功'
      })
    },
    async confirmFreeStorageDurationSetting(){
      const { data: res } = await this.$http.post('customer/freeStorageDurationSetting', this.freeStorageDurationSettingInfo);
      if (res.code != 200) {
        this.$message({
          type: 'warning',
          message: res.message
        })
      }
      this.freeStorageDurationSettingDialogVisible = false
      this.$message({
        type: 'success',
        message: '操作成功'
      })
    },
    async confirmLogisticsCompanySetting(){
      if (this.logisticsCompanySettingInfo.logisticsCompanyOption.length > 0){
        this.logisticsCompanySettingInfo.logisticsCompanyOption = this.logisticsCompanySettingInfo.logisticsCompanyOption.join(',')
      }else {
        this.logisticsCompanySettingInfo.logisticsCompanyOption = ''
      }
      const { data: res } = await this.$http.post('customer/logisticsCompanySetting', this.logisticsCompanySettingInfo);
      if (res.code != 200) {
        this.$message({
          type: 'warning',
          message: res.message
        })
      }
      this.logisticsCompanySettingDialogVisible = false
      this.$message({
        type: 'success',
        message: '操作成功'
      })
    },
    // 更新协议
    async updateAgreement() {
      this.agreementInfo = {
        agreementType: '',
        version: '',
        agreementUrl: '',
        agreementFileName: '',
      };
      this.currentAgreement = null;
      this.agreementDialogVisible = true;
      this.$nextTick(() => {
        if (this.$refs.agreementForm) {
          this.$refs.agreementForm.clearValidate();
        }
      });
    },
    async onAgreementTypeChange() {
      if (this.agreementInfo.agreementType) {
        const { data: res } = await this.$http.get('/agreementConfig/getList');
        if (res.code == 200) {
          const list = res.data.filter(item => item.type == this.agreementInfo.agreementType);
          this.currentAgreement = list.length > 0 ? list[0] : null;
        }
      } else {
        this.currentAgreement = null;
      }
    },
    agreementDialogClose() {
      this.agreementInfo = {
        agreementType: '',
        version: '',
        agreementUrl: '',
        agreementFileName: '',
      };
      this.currentAgreement = null;
    },
    confirmUpdateAgreement() {
      this.$refs.agreementForm.validate(async (valid) => {
        if (valid) {
          const params = {
            type: this.agreementInfo.agreementType,
            version: this.agreementInfo.version,
            url: this.agreementInfo.agreementUrl,
            fileName: this.agreementInfo.agreementFileName,
          };
          const {data: res} = await this.$http.post('/agreementConfig/save', params);
          if (res.code == 200) {
            this.$message.success('操作成功');
            this.agreementDialogVisible = false;
          } else {
            this.$message.error(res.message || '操作失败');
          }
        }
      });
    },
    //绑定库位
    async storageLocation(row){
      console.log('row',row)
      // this.getUserLocator(row);
      const { data: res } = await this.$http.get('/cms/locator/dropDownList');

      this.storageLocationList = res.data;
      // this.storageLocationInfo = {...row,locatorId:Number(row.locatorId)}

      // this.storageLocationInfo = {...row,locatorId:Number(row.locatorId)}
      this.storageLocationInfo = {...row, locatorId: row.locatorIds}
      console.log('this.storageLocationList',this.storageLocationList)
      this.storageLocationDialogVisible = true
      /*   if (row.storageLocationOption != null && row.storageLocationOption != ''){
           row.storageLocationOption = row.storageLocationOption.split(',')
         }*/
    },

    //查询用户绑定库位
    async getUserLocator(row){
      const { data: res } = await this.$http.get('/cms/locator/getUserLocator',{params:{userId:row.userId}});
      if (res.data){
        this.inspectSettingInfo.locatorId = res.data.locatorId;
      }
    },

    // 提交绑定
    async storageLocationSetting(){
      /*      if (this.inspectSettingInfo.storageLocationOption.length > 0){
              this.inspectSettingInfo.storageLocationOption = this.inspectSettingInfo.storageLocationOption.join(',')
            }else {
              this.inspectSettingInfo.storageLocationOption = ''
            }*/

      /*const { data: res } = await this.$http.post('/cms/locator/updateUserLocator2',null,
          {params:
                {
                  locatorId : this.storageLocationInfo.locatorId,
                  userId : this.storageLocationInfo.userId
                }});*/
      const params = {
        locatorId : this.storageLocationInfo.locatorId,
        userId : this.storageLocationInfo.userId
      }
      const { data: res } = await this.$http.post(
          "/cms/locator/updateUserLocator2",
          params
      );
      if (res.code != 200) {
        this.$message({
          type: 'warning',
          message: res.message
        })
      }
      this.storageLocationDialogVisible = false
      this.getCustomerList();
      this.$message({
        type: 'success',
        message: '操作成功'
      })
    },
  },

  created () {
    this.getCustomerList();
  },
};
</script>

<style lang="less" scoped>
.role-page > .search-container {
  height: 60px !important;
}
.el-table .el-button--small {
  padding: 4px 10px;
}
.zcl{

}
.change-upload-size /deep/ .my-upload-set-mini {
  width: 100%;
}
.change-upload-size /deep/ .my-upload-set-mini .el-upload-list__item {
  width: 100%;
}
.change-upload-size /deep/ .my-upload-set-mini .el-upload-list__item-name {
  width: auto;
  padding-right: 20px;
}
// .el-dialog{
//   height: 80% !important;
//   overflow: auto !important;
// }
</style>
